module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Titterten-211a522b5974063a6fbfe77869037404.png";